import SetFiscalRegimeError from './SetFiscalRegimeError';
class InvalidAutomaticInvoicingStatus extends SetFiscalRegimeError {
    constructor(options) {
        super('Investor trying to set a fiscal regime while automatic invoicing is not in progress', options);
    }
}
export default InvalidAutomaticInvoicingStatus;
